export const TEXT_PADDING = 10;

export function getFontSizeToFitForString(text: string, maxWidth: number, ctx: CanvasRenderingContext2D) {
  ctx.font = `1px Inter`;
  return maxWidth / ctx.measureText(text).width;
}

export function getFontSizeToFitForStrings(lines: string[], maxWidth: number, ctx: CanvasRenderingContext2D) {
  let fontSize = Infinity;
  for (let i = 0; i < lines.length; i++) {
    fontSize = Math.min(fontSize, getFontSizeToFitForString(lines[i], maxWidth, ctx));
  }
  return fontSize;
}
